<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>
        <div class="col text-right">
          <base-button type="primary" size="sm" v-on:click="newLeadTrace">Nuevo</base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush custom-text-wrap"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="data">
        <template slot="columns">
          <th>Estatus</th>
          <th>Comentarios</th>
          <th>Fecha</th>
        </template>

        <template slot-scope="{row}">
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.status}}</span>
              </div>
            </div>
          </th>
          <td>{{row.comments}}</td>
          <td>{{formatDate(row.created)}}</td>
        </template>

      </base-table>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'leadstracing-table',
    props: {
      type: {
        type: String
      },
      title: String,
      data: Array,
      pagination: Object
    },
    data() {
      return {
        tableData: [],
      }
    },
    computed: {
      banks() { return this.$store.state.banks }
    },
    async created() { },
    methods: {
      formatDate(date) {
        return this.$moment(date).format("DD MMM, YYYY  HH:mm:ss")
      },
      newLeadTrace() {
        this.$emit("newLeadTrace")
      }
    }
  }
</script>
<style>
</style>
